import { h } from 'preact';

import Dashboard from './components/dashboard/dashboard.jsx';

import globalErrorHandler from './utils/errorHandler.js';
import { loadAllEndpoints } from './utils/endpointUtils.js';
import { preloadAccountData } from './utils/rmUtils.js';

function bootEndpoints() {
  loadAllEndpoints('v1').catch(globalErrorHandler);
  loadAllEndpoints('v2').catch(globalErrorHandler);
}

function rebelMousePrewarm() {
  preloadAccountData().catch(globalErrorHandler);
}

function App(_props) {
  bootEndpoints();
  rebelMousePrewarm();

  return h(Dashboard);
}

export default App;
